// extracted by mini-css-extract-plugin
module.exports = {"stock-list":"_2y7OS25S46NHWvJYrk_p_f"};